export enum RouteName {
    ARTICLE_SINGLE = 'articleSingle',
    VIDEO_SINGLE = 'videoSingle',
    PODCAST_SINGLE = 'podcastSingle',
}
export enum ArticlePublishersName {
    PUBLIC = 'FrenchFounders public',
    LES_TALENTS = 'LesTalents',
    NETWORK = 'Network',
    CLUB = 'Club',
    IC = 'IC',
    VC = 'VC',
}

export enum ResourceType {
    ARTICLE = RouteName.ARTICLE_SINGLE,
    VIDEO = RouteName.VIDEO_SINGLE,
    PODCAST = RouteName.PODCAST_SINGLE,
}
